import {BeiEinkunftenAusEnum} from '../v2024';

export const BeiEinkunftenAusEnumLabels = {
    _13: '13' as BeiEinkunftenAusEnum,
    _14: '14' as BeiEinkunftenAusEnum,
    _15: '15' as BeiEinkunftenAusEnum
};

